// App.js

import React, { useState } from 'react';

import PocketBase from 'pocketbase';

const App = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);

  const pb = new PocketBase('https://scorecord.pockethost.io')


  const handleLogin = async () => {
    if(email.trim().length===0 || email.match('/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/')){
      alert('Enter Valid Email')
      return;
    }

    if(password.trim().length===0 || password.length<8){
      alert('Enter Valid 8 Characters Password')
      return;
    }
    
    try {
      // Use Appwrite SDK to create a session (login)
      const result = await pb.collection('users').authWithPassword(email,password);
      console.log(result)
      setLoggedIn(true);
    } catch (error) {
      console.error(error);
      alert(`Login Failure: ${error.message}`);
    }
  };

  const handleDeleteAccount = async () => {
    try {
      // Use Appwrite SDK to delete the logged-in user account
      await pb.collection('users').delete(pb.authStore.model.id);
      alert('Account deleted successfully!');
      setLoggedIn(false)
    } catch (error) {
      console.error(error);
      alert('Account deletion failed. Please try again.');
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div className="card" style={{ maxWidth: '400px', width: '100%', backgroundColor: '#ffffff', borderRadius: '8px', boxShadow: '0 0 15px rgba(0, 0, 0, 0.2)', padding: '20px', margin: '20px', textAlign: 'center', color: '#333' }}>
        {loggedIn ? (
          <div>
            <h2 style={{ color: '#333' }}>Account Deletion Confirmation</h2>
            <p>Your account has been logged in successfully.</p>
            <p>Do you want to delete your account?</p>
            <button onClick={handleDeleteAccount} style={{ background: '#d9534f', color: '#fff', padding: '10px 20px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px' }}>Yes, Delete My Account</button>
          </div>
        ) : (
          <div>
            <h2 style={{ color: '#333' }}>Login</h2>
            <form>
              <div style={{ marginBottom: '15px' }} className="input-container">
                <label htmlFor="email" style={{ display: 'flex', marginBottom: '5px' }}>Email:</label>
                <input type="email" id="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box', borderRadius: '4px', border: '1px solid #ccc' }} required />
              </div>
              <div style={{ marginBottom: '15px' }} className="input-container">
                <label htmlFor="password" style={{ display: 'flex', marginBottom: '5px' }}>Password:</label>
                <input type={showPassword ? 'text' : 'password'} id="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box', borderRadius: '4px', border: '1px solid #ccc' }} required />
                <div style={{display: 'flex', marginTop: '8px'}}>
                <input type="checkbox" onClick={() => setShowPassword(!showPassword)} /> Show Password
                </div>
              </div>
              <button type="button" onClick={handleLogin} style={{ background: '#5bc0de', color: '#fff', padding: '10px 20px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px' }}>Login</button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default App;
